import { Component } from '@angular/core';
// import {LoginComponent} from './login/login.component';
import 'rxjs/add/operator/pairwise';
import 'rxjs/add/operator/filter';
import { Router } from '@angular/router';
import { RoutesRecognized } from '@angular/router';
import { PreviousRouteService } from '@app/shared/services/previous-route.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  address: string;  

  constructor(
    private router: Router,
    private previousRouteService: PreviousRouteService,
  ) { }

  ngOnInit() {
    this.router.events
      .filter(e => e instanceof RoutesRecognized)
      .pairwise()
      .subscribe((e: any[]) => {
        //console.log('referrer', e);
        if (e[1] && e[1].url === '/login') {
          let currentUser = sessionStorage.getItem('currentUser');
          let token = this.getToken(currentUser);
          if (token == null || token === '') {

          } else {
           //
            this.router.navigateByUrl(e[0].url);
          }
        } else if (e[0] && e[0].url === '/login') {
          let currentUser = sessionStorage.getItem('currentUser');
          let token = this.getToken(currentUser);
          if (token == null || token === '') {

          } else {
           //
            this.router.navigateByUrl(e[1].url);
          }
        } else {
          if (e[1]) {
            this.previousRouteService.setCurrentUrl(e[1].url);
            // this.previousRouteService.removeCurrentHistory(e[1].url)
            this.previousRouteService.addHistory(e[0].url, e[1].url);
          }
          if (e[0]) {
            this.previousRouteService.setPreviousUrl(e[0].url);
            // this.previousRouteService.addHistory(e[0].url)
          }
        }
      });
  }



  getAddress(place: Object) {
    this.address = place['formatted_address'];
    //console.log('getAddress==>', place['formatted_address']);
  }

  private getToken(currentUser): string {
    currentUser = JSON.parse(currentUser);
   //

    if (currentUser != null) {
      return currentUser.token;
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts